import { useLocalStorage } from '../../hooks/useLocalStorage';
import { Outlet } from 'react-router-dom';
import Menu from '../Menu/Menu';
import TopBar from '../TopBar/TopBar';
import styles from './Crm.module.css';

function Crm() {
    const [isCollapsed, setIsCollapsed] = useLocalStorage('isCollapsed', false);

    return (
        <div className={styles.container}>
            <div className={`${styles.menuWrapper} ${isCollapsed ? styles.collapsed : ''}`}>
                <Menu isCollapsed={isCollapsed} onToggleCollapse={() => setIsCollapsed(!isCollapsed)} />
            </div>
            <div className={styles.rightPane}>
                <TopBar />
                <div className={styles.contentWrapper}>
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default Crm;
